import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

//import { theme } from '@ecp/common/src/style/theme/default';
import boTheme from '@ecp/common/src/style/theme/bo';
import { FlexBox, FlexBoxCenter } from '@ecp/common/src/layouts/flex/styled';
import PaginationUnstyled, {
  paginationButtonClassNames,
} from '@ecp/common/src/components/unstyled/pagination/PaginationUnstyled';
import { ReactComponent as FirstIcon } from '@ecp/common/src/assets/icon/icon__bo__first.svg';
import { ReactComponent as PrevIcon } from '@ecp/common/src/assets/icon/icon__bo__prev.svg';
import { ReactComponent as NextIcon } from '@ecp/common/src/assets/icon/icon__bo__next.svg';
import { ReactComponent as LastIcon } from '@ecp/common/src/assets/icon/icon__bo__last.svg';

const FirstButton = styled(FirstIcon)`
  cursor: pointer;
  margin-right: 6px;
`;

const PrevButton = styled(PrevIcon)`
  cursor: pointer;
  margin-right: 20px;
`;

const NextButton = styled(NextIcon)`
  cursor: pointer;
  margin-left: 20px;
`;

const LastButton = styled(LastIcon)`
  cursor: pointer;
  margin-left: 6px;
`;

const PageNumber = styled(FlexBoxCenter)`
  padding: 0 5px;
  font-weight: ${boTheme.font.weight.regular};
  color: ${boTheme.color.sub1};
  font-size: ${(props) => props.theme.font.size.small};
  min-width: 28px;
  height: 28px;
  line-height: 28px;
  cursor: pointer;
  user-select: none;
  &.${paginationButtonClassNames.selected} {
    color: ${boTheme.color.page1};
    border: 1px solid ${boTheme.color.page2};
    box-sizing: border-box;
    border-radius: 3px;
    background-color: ${boTheme.color.page3};
  }
`;
const Pagination = (props) => {
  return (
    <>
      {props.totalCount > 0 && (
        <PaginationUnstyled
          rootComponent={FlexBox}
          firstButtonComponent={FirstButton}
          prevButtonComponent={PrevButton}
          nextButtonComponent={NextButton}
          lastButtonComponent={LastButton}
          pageNumberComponent={PageNumber}
          {...props}
        />
      )}
    </>
  );
};

Pagination.displayName = 'Pagination';

export default Pagination;

Pagination.propTypes = {
  page: PropTypes.number,
  totalCount: PropTypes.number,
  defaultPage: PropTypes.number,
  countPerPage: PropTypes.number,
  numberOfPageGroup: PropTypes.number,
  hideFirstButton: PropTypes.bool,
  hidePrevButton: PropTypes.bool,
  hideNextButton: PropTypes.bool,
  hideLastButton: PropTypes.bool,
  onPageChange: PropTypes.func,
};
